<!-- <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar> -->

<!-- <mat-toolbar>
<mat-icon class="me-2" mat-list-icon>playlist_add_check</mat-icon>
<span>
  <h1>{{ 'ORDER_LIST.TITLE' | transloco }}</h1>
</span>
</mat-toolbar> -->

<div class="page-container">
  <!-- Search Section -->
  <div class="search-container">
    <div class="search-controls">
      <!-- Search Type Dropdown -->
      <mat-form-field appearance="outline" class="search-type-select">
        <mat-label>Search Type</mat-label>
        <mat-select [(value)]="selectedSearchType" (selectionChange)="onSearchTypeChange()" [disabled]="isLoading">
          <!-- <mat-option value="common">
          <mat-icon>search</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.SEARCH' | transloco }}</span>
        </mat-option>
        <mat-option value="name">
          <mat-icon>person</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.NAME' | transloco }}</span>
        </mat-option>
        <mat-option value="email">
          <mat-icon>email</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.EMAIL' | transloco }}</span>
        </mat-option>
        <mat-option value="phone">
          <mat-icon>phone</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.PHONE' | transloco }}</span>
        </mat-option> -->
        <mat-option value="registration">
          <mat-icon>directions_car</mat-icon>
          <span class="ml-2">{{ 'ORDER_LIST.CARID' | transloco }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Search Input -->
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ getSearchPlaceholder() | transloco }}</mat-label>
      <input matInput [(ngModel)]="currentSearchValue" [placeholder]="getSearchPlaceholder() | transloco"
        [disabled]="isLoading">
      <mat-icon matSuffix>{{ getSearchIcon() }}</mat-icon>
    </mat-form-field>

    <!-- Search Button -->
    <button mat-raised-button color="primary" (click)="executeSearch()"
      [disabled]="isLoading || !currentSearchValue?.trim()" class="search-button">
      <mat-icon>search</mat-icon>
      Search
    </button>

    <!-- Clear Search Button -->
    <button mat-stroked-button (click)="clearSearch()" [disabled]="isLoading" class="clear-search-button">
      <mat-icon>clear</mat-icon>
      Clear
    </button>
  </div>
</div>

<!-- Filters Section -->
<div class="filters-container">
  <div class="filters-header" (click)="toggleFilters()">
    <div class="filters-title">
      <mat-icon>filter_list</mat-icon>
      <span>{{ 'ORDER_LIST.FILTERS' | transloco }}</span>
      @if (getActiveFiltersCount() > 0) {
        <mat-chip-set class="filter-count">
          <mat-chip>{{ getActiveFiltersCount() }} {{ 'ORDER_LIST.ACTIVE_FILTERS' | transloco }}</mat-chip>
        </mat-chip-set>
      }
    </div>
    <mat-icon class="expand-icon" [class.expanded]="filtersExpanded">expand_more</mat-icon>
  </div>

  <div class="filters-content" [class.expanded]="filtersExpanded">
    <div class="filters-grid">
      <!-- Multi-Select Status Filter -->
      <div class="filter-group multiple-select">
        <label class="filter-label">{{ 'ORDER_LIST.STATUS' | transloco }}</label>
        <mat-form-field>
          <!-- <mat-label>{{ 'ORDER_LIST.STATUS' | transloco }}</mat-label> -->
          <mat-select [placeholder]="'ORDER_LIST.STATUS' | transloco" [(value)]="selectedStatuses" multiple
            (selectionChange)="onStatusChange()" [disabled]="isLoading">
            @for (status of additionalServiceStatusOptions; track status) {
              <mat-option [value]="status.value">
                {{ status.name }}
              </mat-option>
            }
          </mat-select>
          @if (selectedStatuses && selectedStatuses.length > 0) {
            <mat-hint>
              {{ selectedStatuses.length }} status(es) selected
            </mat-hint>
          }
        </mat-form-field>
      </div>

      <!-- Multi-Select AS Status Filter -->
      <div class="filter-group multiple-select">
        <label class="filter-label">{{ 'PRICING.ADDITIONAL_SERVICES.ADDITIONAL_SERVICES' | transloco }}</label>
        <mat-form-field>
          <mat-select [placeholder]="'PRICING.ADDITIONAL_SERVICES.ADDITIONAL_SERVICES' | transloco"
            [(value)]="selectedAdditionalServices" multiple (selectionChange)="applyFilters()" [disabled]="isLoading">
            @for (status of additionalServiceOptions; track status) {
              <mat-option [value]="status.value">
                {{ status.name | translateAttribute}}
              </mat-option>
            }
          </mat-select>
          @if (selectedAdditionalServices && selectedAdditionalServices.length > 0) {
            <mat-hint>
              {{ selectedAdditionalServices.length }} {{ 'PRICING.ADDITIONAL_SERVICES.ADDITIONAL_SERVICES' | transloco
              }} selected
            </mat-hint>
          }
        </mat-form-field>
      </div>

      <!-- Multi-Select Parking Filter -->
      <div class="filter-group multiple-select">
        <label class="filter-label">{{ 'PARKING_PRICING.PARKINGS' | transloco }}</label>
        <mat-form-field>
          <mat-select [placeholder]="'PARKING_PRICING.PARKINGS' | transloco" [(value)]="selectedParking" multiple
            (selectionChange)="applyFilters()" [disabled]="isLoading">
            @for (status of parkingOptions; track status) {
              <mat-option [value]="status.value">
                {{ status.name }}
              </mat-option>
            }
          </mat-select>
          @if (selectedParking && selectedParking.length > 0) {
            <mat-hint>
              {{ selectedParking.length }} {{ 'PARKING_PRICING.PARKINGS' | transloco }} selected
            </mat-hint>
          }
        </mat-form-field>
      </div>


      <!-- Planned Date Range Filter -->
      <div class="filter-group">
        <label class="filter-label">{{ 'ADDITIONAL_SERVICE_EDIT.PLANNED_DATE' | transloco }}</label>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'ADDITIONAL_SERVICE_EDIT.PLANNED_DATE' | transloco }}</mat-label>
          <mat-date-range-input [formGroup]="plannedDateRange" [rangePicker]="plannedRangePicker"
            [disabled]="isLoading">
            <input matStartDate formControlName="start" placeholder="{{ 'ORDER_LIST.FROM' | transloco }}">
            <input matEndDate formControlName="end" placeholder="{{ 'ORDER_LIST.TO' | transloco }}">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="plannedRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #plannedRangePicker></mat-date-range-picker>
          @if (plannedDateRange.controls.start.hasError('matStartDateInvalid')) {
            <mat-error>
              Invalid start date
            </mat-error>
          }
          @if (plannedDateRange.controls.end.hasError('matEndDateInvalid')) {
            <mat-error>
              Invalid end date
            </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- From Date Range Filter -->
      <div class="filter-group">
        <label class="filter-label">{{ 'FORM.PARKING_FROM' | transloco }}</label>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'FORM.PARKING_FROM' | transloco }}</mat-label>
          <mat-date-range-input [formGroup]="fromRange" [rangePicker]="fromRangePicker" [disabled]="isLoading">
            <input matStartDate formControlName="start" placeholder="{{ 'ORDER_LIST.FROM' | transloco }}">
            <input matEndDate formControlName="end" placeholder="{{ 'ORDER_LIST.TO' | transloco }}">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="fromRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #fromRangePicker></mat-date-range-picker>
          @if (fromRange.controls.start.hasError('matStartDateInvalid')) {
            <mat-error>
              Invalid start date
            </mat-error>
          }
          @if (fromRange.controls.end.hasError('matEndDateInvalid')) {
            <mat-error>
              Invalid end date
            </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- To Date Range Filter -->
      <div class="filter-group">
        <label class="filter-label">{{ 'FORM.PARKING_TO' | transloco }}</label>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'FORM.PARKING_TO' | transloco }}</mat-label>
          <mat-date-range-input [formGroup]="toRange" [rangePicker]="toRangePicker" [disabled]="isLoading">
            <input matStartDate formControlName="start" placeholder="{{ 'ORDER_LIST.FROM' | transloco }}">
            <input matEndDate formControlName="end" placeholder="{{ 'ORDER_LIST.TO' | transloco }}">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="toRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #toRangePicker></mat-date-range-picker>
          @if (toRange.controls.start.hasError('matStartDateInvalid')) {
            <mat-error>
              Invalid start date
            </mat-error>
          }
          @if (toRange.controls.end.hasError('matEndDateInvalid')) {
            <mat-error>
              Invalid end date
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="filter-actions">
      <button mat-raised-button color="primary" (click)="applyFilters()" [disabled]="isLoading">
        <mat-icon>search</mat-icon>
        {{ 'ORDER_LIST.APPLY_FILTERS' | transloco }}
      </button>
      <button mat-stroked-button (click)="clearFilters()" [disabled]="isLoading">
        <mat-icon>clear</mat-icon>
        {{ 'ORDER_LIST.CLEAR_FILTERS' | transloco }}
      </button>
    </div>
  </div>
</div>

<!-- Results Section -->
<div class="results-section">
  <mat-paginator #paginator [length]="totalData" [pageSizeOptions]="pageSizes" showFirstLastButtons
  [disabled]="isLoading"></mat-paginator>

  <div class="overflow-auto">
    <table mat-table matSort [dataSource]="dataSource" class="results-table mat-elevation-z2">
      <ng-container matColumnDef="orderNr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.ORDER_NR' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.orderNr }} </td>
      </ng-container>

      <ng-container matColumnDef="regNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.CARID' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.regNo }} </td>
      </ng-container>

      <ng-container matColumnDef="parkingName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PARKING_PRICING.PARKINGS' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.parkingName }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.NAME' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.name | translateAttribute }}</td>
      </ng-container>

      <ng-container matColumnDef="from">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FORM.PARKING_FROM' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.from | date:'yyyy-MM-dd HH:mm'}}</td>
      </ng-container>

      <ng-container matColumnDef="to">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FORM.PARKING_TO' | transloco }}</th>
        <td mat-cell *matCellDef="let order"> {{ order.to | date:'yyyy-MM-dd HH:mm'}}</td>
      </ng-container>

      <ng-container matColumnDef="planned">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ADDITIONAL_SERVICE_EDIT.PLANNED_DATE' | transloco }}
        </th>
        <td mat-cell *matCellDef="let order"> {{ order.planned | date:'yyyy-MM-dd' }} </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.STATUS' | transloco }}</th>
        <td mat-cell *matCellDef="let order">
          <app-status-badge [text]="order.status"
          [color]="getAdditionalServiceStatusColor(order.status)"></app-status-badge>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let order; columns: displayedColumns;" (click)="goToOrder(order.orderId)"
      class="clickable-row"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
          <div class="no-data-content">
            <mat-icon>search_off</mat-icon>
            <span>{{ 'ORDER_LIST.NO_MATCH' | transloco }}</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
</div>
